import { MGPMap, MGPOptional, Set } from '@everyboard/lib';
import { Player } from '../../jscaip/Player';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { MartianChessPiece } from './MartianChessPiece';
export class MartianChessCapture {
    captures;
    static of(pieces) {
        const map = new MGPMap();
        for (const piece of pieces) {
            MartianChessCapture.addToMap(map, piece);
        }
        return new MartianChessCapture(map);
    }
    static addToMap(map, piece) {
        const oldValue = map.get(piece);
        if (oldValue.isPresent()) {
            map.replace(piece, oldValue.get() + 1);
        }
        else {
            map.set(piece, 1);
        }
    }
    constructor(captures) {
        this.captures = captures;
        captures.makeImmutable();
    }
    toValue() {
        let sum = 0;
        for (const [piece, value] of this.captures) {
            sum += piece.getValue() * value;
        }
        return sum;
    }
    add(piece) {
        const newMap = this.captures.getCopy();
        MartianChessCapture.addToMap(newMap, piece);
        return new MartianChessCapture(newMap);
    }
}
export class MartianChessState extends GameStateWithTable {
    lastMove;
    countDown;
    static WIDTH = 4;
    static HEIGHT = 8;
    static PLAYER_ZERO_TERRITORY = new Set([4, 5, 6, 7]);
    static PLAYER_ONE_TERRITORY = new Set([0, 1, 2, 3]);
    static isOnBoard(coord) {
        return coord.isInRange(MartianChessState.WIDTH, MartianChessState.HEIGHT);
    }
    static isNotOnBoard(coord) {
        return MartianChessState.isOnBoard(coord) === false;
    }
    captured;
    constructor(board, turn, lastMove = MGPOptional.empty(), countDown = MGPOptional.empty(), captured) {
        super(board, turn);
        this.lastMove = lastMove;
        this.countDown = countDown;
        if (captured == null) {
            captured = new MGPMap([
                { key: Player.ZERO, value: MartianChessCapture.of([]) },
                { key: Player.ONE, value: MartianChessCapture.of([]) },
            ]);
        }
        captured.makeImmutable();
        this.captured = captured;
    }
    getPlayerTerritory(player) {
        if (player === Player.ZERO) {
            return MartianChessState.PLAYER_ZERO_TERRITORY;
        }
        else {
            return MartianChessState.PLAYER_ONE_TERRITORY;
        }
    }
    isTherePieceOnPlayerSide(piece) {
        const currentPlayer = this.getCurrentPlayer();
        const playerTerritory = this.getPlayerTerritory(currentPlayer);
        for (const y of playerTerritory) {
            for (let x = 0; x < MartianChessState.WIDTH; x++) {
                if (this.getPieceAtXY(x, y) === piece) {
                    return true;
                }
            }
        }
        return false;
    }
    getScoreOf(player) {
        return this.captured.get(player).get().toValue();
    }
    getEmptyTerritory() {
        if (this.isTerritoryEmpty(Player.ZERO)) {
            return MGPOptional.of(Player.ZERO);
        }
        else if (this.isTerritoryEmpty(Player.ONE)) {
            return MGPOptional.of(Player.ONE);
        }
        else {
            return MGPOptional.empty();
        }
    }
    isTerritoryEmpty(player) {
        const playerTerritory = this.getPlayerTerritory(player);
        for (const y of playerTerritory) {
            for (let x = 0; x < MartianChessState.WIDTH; x++) {
                if (this.getPieceAtXY(x, y) !== MartianChessPiece.EMPTY) {
                    return false;
                }
            }
        }
        return true;
    }
    isInOpponentTerritory(coord) {
        const opponent = this.getCurrentOpponent();
        const opponentTerritory = this.getPlayerTerritory(opponent);
        return opponentTerritory.contains(coord.y);
    }
    isInPlayerTerritory(coord) {
        const player = this.getCurrentPlayer();
        const playerTerritory = this.getPlayerTerritory(player);
        return playerTerritory.contains(coord.y);
    }
    getCapturesOf(player) {
        const capture = this.captured.get(player).get();
        return [
            capture.captures.get(MartianChessPiece.PAWN).getOrElse(0),
            capture.captures.get(MartianChessPiece.DRONE).getOrElse(0),
            capture.captures.get(MartianChessPiece.QUEEN).getOrElse(0),
        ];
    }
}
